export const USE_BEARER = true;
export const ACCESS_TOKEN_KEY = 'meridian_b2b_access_token';
export const REFRESH_TOKEN_KEY = 'meridian_b2b_refresh_token';
export const REFRESH_TIMESTAMP_KEY = 'meridian_b2b_timestamp_key';
export const NUMBER_ANIMATION = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

export const COMMON_FORM_ERRORS = {
  REQUIRED: '*Поле обязательно для заполнения',
};

export const PAGE_TITLES = {
  summary: 'Сводка',
  users: 'Пользователи',
  engineers: 'Инженеры',
  events: 'События',
  addresses: 'Адреса',
  controllers: 'Устройства',
  integrations: 'Интеграции',
  reports: 'Отчеты',
  settings: 'Настройки',
  profile: 'Личный кабинет',
  risks: 'Риски',
  support: 'Поддержка',
};
